import { history } from "../../helpers/History";
import { ApplicationCloseReason } from "sdk/index";
import { StoreModel } from '../../models/Index';

export default function goHome(Store: StoreModel, event: any) {
    //Closing app
    return Store.sdk.closeApp(ApplicationCloseReason.HomeButtonClick)
        .then((_: any) => {
        history.push({ pathname: '/', search: history.location.search });
    });
}
